import { keys, map } from 'lodash';
import { forkJoin, Observable } from 'rxjs';
import { DatabaseService } from './database.service';

export function connected(): Observable<void> {
  throw new Error('Not Implemented');
}

export function upgraded(service: DatabaseService): Observable<any> {
  service.syncLog.trace('DB Upgrade: Updating object stores.');
  return forkJoin(
    map(keys(service.options.objectStores), key => service.createObjectStore(key, service.options.objectStores[key])),
  );
}
